import { useSelector, useDispatch } from "react-redux";
import { updateUserDetails } from "../redux/auth/actions";
import { toErrorMessage } from "../helpers/errorText";

export const UseAuth = () => {
  const loginCredentials = useSelector(
    (state) => state.authReducer.authenticated,
  );
  return loginCredentials;
};

export const UseAuthError = () => {
  const loginCredentials = useSelector(
    (state) =>
      state.authReducer.status === "error" || state.authReducer.errorMessage,
  );
  return loginCredentials;
};

export const UseAuthStatus = () => {
  const status = useSelector((state) => state.authReducer.status);
  return status;
};

export const UseAuthErrorMessage = () => {
  const errorMessage = useSelector(
    (state) => state.authReducer.errorMessage,
  );
  if (!errorMessage) return "";
  return toErrorMessage(errorMessage, "");
};

export const UseUserDetails = () => {
  const getUserDetails = useSelector((state) => state.authReducer.userDetails ?? {});
  return getUserDetails;
};

export const UseUpdateUserDetails = () => {
  const dispatch = useDispatch();

  const updateUserDetailsAction = (userDetails) => {
    dispatch(updateUserDetails(userDetails));
  };
  return updateUserDetailsAction;
};


export const UseCompanyName = () => {
  const getCompanyName = useSelector(
    (state) => state.authReducer.userDetails?.company,
  );
  return getCompanyName;
};

export const UseCompanyId = () => {
  const getCompanyId = useSelector(
    (state) => state.authReducer.userDetails?.companyId,
  );
  return getCompanyId;
};

export const UseUserId = () => {
  const getUserId = useSelector((state) => state.authReducer.userDetails?._id);
  return getUserId;
};

export const UseIsAdmin = () => {
  const isAdmin = useSelector(
    (state) => state.authReducer.userDetails?.isAdmin && !(state.usersReducer.viewAsUser),
  );
  return isAdmin;
};

export const UseIsAffiliate = () => {
  const isAffiliate = useSelector(
    // Only officially registered Affiliate Partners with level > 0
    (state) => state.authReducer.userDetails?.affiliate?.level ?? false,
  );
  return isAffiliate;
};

export const UseLoading = () => {
  const loading = useSelector((state) => state.authReducer.isLoading);
  return loading;
};

export const UseIsPrime = () => {
  const isPrime = useSelector((state) => state.authReducer.isPrime);
  return isPrime;
};

export const UseIsDemo = () => {
  const isDemo = useSelector((state) => state.authReducer.isDemo);
  return isDemo;
};

export const UseAccess = () => {
  const access = useSelector((state) => state.authReducer.access);
  return access;
};
